export const SIGNUP_ACTION = "SignUpAction";
